module.exports = __webpack_public_path__ + "img/resident-monthly.6127e944.png";